import React, { memo } from 'react';

import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';
import { useStoreIcon, IconName } from 'shared/icons';

import { Card, CardContent, ChevronWrapper, PolicyIcon } from './styles';

interface PolicyCardProps {
  icon: string;
  text: string;
  onClick: () => void;
}

const PolicyCard = ({ icon, text, onClick }: PolicyCardProps) => {
  const ChevronRight = useStoreIcon(IconName.CHEVRON_RIGHT);

  return (
    <Card type="button" onClick={onClick} data-test="policy-card-v3">
      <PolicyIcon src={icon} alt={text} />
      <CardContent dangerouslySetInnerHTML={{ __html: sanitizeHTML(text) }} />
      <ChevronWrapper>
        <ChevronRight size="16px" />
      </ChevronWrapper>
    </Card>
  );
};

export default memo(PolicyCard);
